import { makeStyles } from '@material-ui/core/styles'

export const bottomSheetMobileInfoWindowStyles = makeStyles((theme) => ({
  mobileInfoWindowContainer: {
    display: 'flex',
    marginTop: '20px',
    paddingLeft: '10px',
    height: '33dvh',
    width: '100%',
    overflowY: 'auto',
    [theme.breakpoints.up(375)]: {
      height: '25dvh',
      bottom: 0,
    },
    [theme.breakpoints.up(390)]: {
      height: '32dvh',
      bottom: 0,
    },
  },
  mapInfoContainer: {
    padding: 10,
    zIndex: 1000,
    background: theme.palette.primary.paper,
    [theme.breakpoints.down('sm')]: {
      top: 110,
      left: 10,
    },
  },
  mapInfoCardContentContainer: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
  },
  mobileMarkerInfoContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100dvw',
    padding: '10px',
  },
  campusContainer: { position: 'absolute', top: '10%', left: '10%' },
  campusImageContainer: {
    paddingBottom: 10,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      alignSelf: 'center',
    },
  },
  campusImage: {
    width: '100%',
    height: '200px',
    borderRadius: '1rem',
    objectFit: 'cover',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  campusImageText: {
    color: 'white',
    background: theme.color.rutgersRed,
    fontSize: '1.4rem',
    fontWeight: 'bold',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.1rem',
    },
  },
  campusText: {
    fontSize: '1.4rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.9rem',
    },
  },
  mapInfoButtonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 1,
  },
  mapInfoTableContainer: {
    marginTop: 10,
    marginBottom: 10,
    display: 'flex',
    justifyContent: 'space-evenly',
  },
  mapInfoTableContentContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  getDirectionsButton: {
    width: 'max-content',
    alignSelf: 'center',
    padding: 10,
    borderRadius: '0.5rem',
    color: 'white',
    background: theme.color.rutgersRed,
    '&:hover': {
      color: 'white',
      background: theme.color.rutgersRed,
    },
  },
  hoursContainer: {
    margin: '10px 0',
  },
  evChargingIconLabel: {
    fontWeight: 600,
    color: theme.palette.components.linkText,
    textDecoration: 'underline',
    '&:hover': {
      color: theme.palette.components.linkText,
    },
  },
}))

export default bottomSheetMobileInfoWindowStyles
